import React, { useState, useEffect, useRef }  from 'react';
import LogInRequired from 'components/header/LogInRequired.jsx';

const LoginButton = ({ }) => {
  return <a href="#" onClick={emitLogInRequired}>{t('nav.login')}</a>
}

export default LoginButton;
